// import { configureStore } from "@reduxjs/toolkit";
// import vebPlansReducer from "../features/VEBPlans/VEBPlansSlice";

// export const store = configureStore({
// 	reducer: {
// 		vebPlans: vebPlansReducer
// 	}
// });

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
/* eslint-disable arrow-parens */
import { configureStore } from "@reduxjs/toolkit";
import vebPlansReducer from "../features/VEBPlans/VEBPlansSlice";
import memberPortalReducer from "../features/member/memberSlice";
import { vebPlansApi } from "../features/VEBPlans/vebPlansApi"; // import your RTK Query API

export const store = configureStore({
	reducer: {
		vebPlans: vebPlansReducer,
		memberPortal: memberPortalReducer,
		[vebPlansApi.reducerPath]: vebPlansApi.reducer // add RTK Query reducer
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(vebPlansApi.middleware) // add RTK Query middleware
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
